import React from "react";
import { StyledSortByContainer, StyledSortByWrapper } from "./style";
import {
  Icon,
  KeyValueCustomSelect,
  Paragraph,
} from "@smartsuite/react-ui/lib";
import { SolutionColors } from "@smartsuite/types";

export enum PowerSearchSortBy {
  FieldName = "field-name",
  FieldType = "field-type",
  FieldAction = "field-action",
}

type SearchSortByOption = Record<string, PowerSearchSortBy | string>;

const options: SearchSortByOption[] = [
  { value: PowerSearchSortBy.FieldName, label: "Field Name" },
  { value: PowerSearchSortBy.FieldType, label: "Field Type" },
  { value: PowerSearchSortBy.FieldAction, label: "Merge Action" },
];

const renderSelectedOption = (option: SearchSortByOption): React.ReactNode => {
  return (
    <Paragraph
      size="xs"
      weight="semibold"
      className="search-sort-by-dropdown__option-selected"
    >
      {"Sort by: "} {option.label}
    </Paragraph>
  );
};

const renderOption = (
  option: SearchSortByOption,
  value: string,
): React.ReactNode => {
  return (
    <Paragraph
      size="m"
      weight="medium"
      color="tertiary"
      styles={{
        padding: "5px 5px 5px 15px",
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span> {option.label}</span>
        {option.value === value && (
          <Icon
            name="checkmark"
            color={SolutionColors.basePrimaryGreen}
            size="S"
            opacity={1}
          />
        )}
      </div>
    </Paragraph>
  );
};

export const SortByDropdown: React.FC<{
  onChangeSort: (order: PowerSearchSortBy) => void;
}> = ({ onChangeSort }) => {
  const [value, setValue] = React.useState<PowerSearchSortBy>(
    PowerSearchSortBy.FieldName,
  );

  return (
    <StyledSortByWrapper>
      <StyledSortByContainer>
        <KeyValueCustomSelect
          value={value}
          options={options}
          placeholderArrowStyle="filled"
          inputBackground="transparent"
          showClear={false}
          zIndex={1000}
          renderSelectedOption={renderSelectedOption}
          renderOption={(option) => renderOption(option, value)}
          onChange={(value) => {
            setValue(value as PowerSearchSortBy);
            onChangeSort(value as PowerSearchSortBy);
          }}
        />
      </StyledSortByContainer>
    </StyledSortByWrapper>
  );
};
